import styles from "./ApplicationUIPrimarySidebar.module.css";
import Each from "../../../components/Each";
import { Route, Routes, Link, useLocation, useNavigate } from 'react-router-dom';
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Icon } from "react-icons-kit"
import { grid } from "react-icons-kit/feather/grid"


import { filePlus } from 'react-icons-kit/feather/filePlus'
import { layers } from "react-icons-kit/feather/layers"
import { paperPlane } from "react-icons-kit/fa/paperPlane"


import { barChart } from "react-icons-kit/fa/barChart"
import { inbox } from "react-icons-kit/fa/inbox"

import { balanceScale } from "react-icons-kit/fa/balanceScale"
import { shield } from "react-icons-kit/fa/shield"

import { userCircle } from 'react-icons-kit/fa/userCircle'
import { questionCircle } from "react-icons-kit/fa/questionCircle"

import { documentText } from 'react-icons-kit/ionicons/documentText'
import { book } from 'react-icons-kit/feather/book'
import { phone } from "react-icons-kit/fa/phone"
import { users } from "react-icons-kit/fa/users"




import { wrench } from "react-icons-kit/fa/wrench"
import { AuthConsole } from "../../../Utils/helper";
const DashBoardSidebar = ({
  onAuthenticationContainerClick,
}) => {
  const [subLink, setSublink] = useState(null)
  const User = useSelector(state => state.User)
  const pathname = useLocation().pathname
  let isEmployer = User.category == 'EMPLOYMENT' || "GENERAL"


  const navigate=useNavigate()
  AuthConsole("Category",User.category);
  
  const links = {
    'Issuer': {
      'General': [
        {
          label: 'Dashboard',
          icon: grid,
          aIcon: '/grid1.svg',
          link: '/dashboard'
        },
        {
          label: '+ Issue New',
          icon: filePlus,
          aIcon: '/filecircleplus1.svg',
          link: '/dashboard/credentials/issue-credentials',
          state: null
        },
        {
          label: 'All Templates',
          icon: layers,
          aIcon: '/badgecheck1.svg',
          link: '/dashboard/mydocuments',
        },
        {
          label: 'Issued Documents',
          icon: paperPlane,
          aIcon: '/badgecheck1.svg',
          link: '/dashboard/credentials',
          // isSubLink: true,
          // subLinks: [
          //   {
          //     label: '+ Issue New',
          //     icon: '/filecircleplus.svg',
          //     aIcon: '/filecircleplus1.svg',
          //     link: '/dashboard/credentials/issue-credentials',
          //     state: null
          //   },
          //   // {
          //   //   label: 'Change Request',
          //   //   icon: '/filecircleplus.svg',
          //   //   aIcon: '/filecircleplus1.svg',
          //   //   link: '/dashboard/credentials',
          //   //   state: { change_request: true }
          //   // }

          // ]
        },
        {
          label: 'Insights',
          icon: barChart,
          aIcon: '/graph1.svg',
          link: '/dashboard/record_insights'
        },
        {
          label: 'Reports',
          icon:  layers,
          aIcon: '/grid1.svg',
          link: '/dashboard/record_reports'
        },
        {
          label: 'Requests',
          icon:  inbox,
          aIcon: '/grid1.svg',
          link: '/dashboard/verification_requests'
        },

        {
          label: 'Appeals',
          icon: balanceScale,
          aIcon: '/grid1.svg',
          link: '/dashboard/DocAppeals'
        },
        // {
        //   label: "Verifier Doc Requests",
        //   icon: shield,
        //   aIcon: "/user2.svg",
        //   link: "/dashboard/verifierDocRequests"
        // },
        {
          label: 'Profile',
          icon: userCircle,
          aIcon: '/user2.svg',
          link: `/dashboard/profile/${User.id}`,
        }
      ]
    },
    'Verifier': {
      'GENERAL': [{
        label: 'Dashboard',
        icon: grid,
        aIcon: '/grid1.svg',
        link: '/dashboard'
      },
      // {
      //   label: 'All Form Response',
      //   icon: '/badgecheck.svg',
      //   aIcon: '/badgecheck1.svg',
      //   link: '/dashboard/verifier-data',
      // },
      {
        label: 'My Requests',
        icon: '/badgecheck.svg',
        aIcon: '/badgecheck1.svg',
        link: '/dashboard/forms/myRequests',
      },
      {
        label: 'Forms',
        icon: '/badgecheck.svg',
        aIcon: '/badgecheck1.svg',
        link: '/dashboard/forms/selectForms',
      },
      // {
      //   label: 'Verify Users',
      //   icon: '/searchoutline.svg',
      //   aIcon: '/searchoutline-2.svg',
      //   link: '/dashboard/emp/packages',
      // },
      {
        label: 'Profile',
        icon: '/user.svg',
        aIcon: '/user2.svg',
        link: `/dashboard/profile/${User.id}`,
      }],
      'VISITOR': [{
        label: 'Dashboard',
        icon: '/grid.svg',
        aIcon: '/grid1.svg',
        link: '/dashboard'
      },
      {
        label: 'My Requests',
        icon: '/badgecheck.svg',
        aIcon: '/badgecheck1.svg',
        link: '/dashboard/forms/myRequests',
      },
      {
        label: 'Forms',
        icon: '/badgecheck.svg',
        aIcon: '/badgecheck1.svg',
        link: '/dashboard/verifier-forms',
      },
      {
        label: 'Profile',
        icon: '/user.svg',
        aIcon: '/user2.svg',
        link: `/dashboard/profile/${User.id}`,
      }],
      'EMPLOYMENT': [{
        label: 'Dashboard',
        icon: grid,
        aIcon: '/grid1.svg',
        link: '/dashboard'
      },
      {
        label: 'Verify Users',
        icon: '/searchoutline.svg',
        aIcon: '/searchoutline-2.svg',
        link: '/dashboard/emp/search',
      },
      {
        label: 'My Requests',
        icon: '/badgecheck.svg',
        aIcon: '/badgecheck1.svg',
        link: '/dashboard/emp/requests',
      },

      // {
      //   label: 'Appeals',
      //   icon: '/grid.svg',
      //   aIcon: '/grid1.svg',
      //   link: '/dashboard/emp/docAppeals'
      // },
      {
        label: 'Profile',
        icon: userCircle,
        aIcon: '/user2.svg',
        link: `/dashboard/profile/${User.id}`,
      },
      // {
      //   label: 'Our Issuers',
      //   icon: users,
      //   aIcon: '/badgecheck1.svg',
      //   link: '/dashboard/Issuers',
      // }
    ]
    }
  }
  function handleLinkClick(index) {
    if (subLink === index) {
      setSublink(null)
    }
    else
      setSublink(index)
  }
  useEffect(() => {
    if (pathname.includes('/credentials')) {
      setSublink(1)
    }
  }, [])
  return (
    <div className={styles.dashBoardSidebar}>
      <div className={styles.main}>
        <Each of={links[User?.user_type][User?.category ]} render={(item, index) => {
          return <div className={styles.overview}>
            <Link to={item.link} className={`${styles.linkLabel} ${pathname === item.link ? styles.active : item.label=="Our Issuers"?styles.zoomAnimation:""}`}>
              <div className={styles.leftContent} onClick={() => handleLinkClick(index)} style={{width:"5rem"}}>
                {/* <img className={styles.gridIcon} alt="" src={pathname === item.link ? item.aIcon : item.icon} /> */}

                {typeof item.icon === "string" ? (
                <img
                  className={styles.gridIcon}
                  alt=""
                  src={pathname === item.link ? item.aIcon : item.icon}
                />
                ) : (
              <Icon icon={item.icon}
                className={`w-6 h-6 ${
                  pathname === item.link ? "text-blue-600" :item.label=="Our Issuers"?styles.zoomAnimation: "text-gray-500"
                }`}

                size={18}
              />
            )}
                {item.label}
              </div>
            </Link>
            {item.isSubLink && subLink === index ? <div className={styles.subLinks}>
              <Each of={item.subLinks} render={(item, index) => {
                return <div className={styles.subLink} style={{ paddingLeft: "25px" }} >
                  <Link to={item.link} className={`${styles.linkLabel} ${pathname === item.link ? styles.active : ''}`} state={item.state}>
                    <div className={styles.leftContent}>
                      {item.label}
                    </div>
                  </Link>
                </div>
              }} />
            </div> : null}
          </div>
        }} />
      </div>
      <div className={styles.separator} />
      {User.user_type=="Verifier" &&User.category=="VISITOR" ? <>
        <div className={styles.docs}>
          <Link to='/dashboard/forms/selectForms' className={`${[styles.linkLabel, styles.leftContent4].join(" ")} ${pathname === '/dashboard/forms/selectForms' ? styles.active : ''}`}>
            {/* <Link to='/dashboard/forms/createForm' className={`${[styles.linkLabel, styles.leftContent4].join(" ")} ${pathname === '/dashboard/forms/createForm' ? styles.active : ''}`}>*/}
            <img className={styles.bookIcon} alt="" src="/book.svg" />
            <div className={styles.pages6} style={{ paddingLeft: "10px" }}>Request Verifications</div>
          </Link>
          <div className={styles.icon1}>
            <img
              className={styles.chevronDownIcon4}
              alt=""
              src="/chevrondown.svg"
            />
          </div>
        </div>
        <div className={styles.separator} />
      </> : null}
      <div className={styles.main1}>
        {/* <div className={styles.docs}>
          <div className={styles.leftContent4}>
            <img className={styles.bookIcon} alt="" src="/book.svg" />
            <div className={styles.pages6}>Docs</div>
          </div>
          <div className={styles.icon1}>
            <img
              className={styles.chevronDownIcon4}
              alt=""
              src="/chevrondown.svg"
            />
          </div>
        </div> */}
        <div className={styles.docs1}>
          <div className={styles.leftContent5}>
            <img className={styles.archiveIcon} alt="" src="/archive.svg" />
            <div className={styles.pages7}>Components</div>
          </div>
          <div className={styles.icon2}>
            <img
              className={styles.chevronDownIcon5}
              alt=""
              src="/chevrondown.svg"
            />
          </div>
        </div>
        <div className={styles.docs2}  onClick={()=>navigate("/dashboard/Help")}>
          <div className={styles.leftContent6}>
            <Icon icon={questionCircle} className="w-6 h-6 text-gray-500" size={18}/>
            <div className={styles.pages8}>Help</div>
          </div>
          <div className={styles.icon3}>
            <img
              className={styles.chevronDownIcon6}
              alt=""
              src="/chevrondown.svg"
            />
          </div>
        </div>
        <div className={styles.docs2} onClick={()=>{navigate("/Term-and-Condition")}}>
          <div className={styles.leftContent6}>
            <Icon icon={documentText} className="w-6 h-6 text-gray-500" size={18}/>
            <div className={styles.pages8}>Terms and Conditions</div>
          </div>
          <div className={styles.icon3}>
            <img
              className={styles.chevronDownIcon6}
              alt=""
              src="/chevrondown.svg"
            />
          </div>
        </div>
        <div className={styles.docs2} onClick={()=>{navigate("/privacy-policy")}}>
          <div className={styles.leftContent6}>
            <Icon icon={book} className="w-6 h-6 text-gray-500" size={18}/>
            <div className={styles.pages8}>Privacy Policy</div>
          </div>
          <div className={styles.icon3}>
            <img
              className={styles.chevronDownIcon6}
              alt=""
              src="/chevrondown.svg"
            />
          </div>
        </div>
        <div className={styles.docs2} onClick={()=>{navigate("/contact-us")}}>
          <div className={styles.leftContent6}>
            <Icon icon={phone} className="w-6 h-6 text-gray-500" size={18}/>
            <div className={styles.pages8}>Contact Us</div>
          </div>
          <div className={styles.icon3}>
            <img
              className={styles.chevronDownIcon6}
              alt=""
              src="/chevrondown.svg"
            />
          </div>
        </div>






        <div className={styles.docs2} onClick={()=>navigate("/Services")}>
          <div className={styles.leftContent6}>
            <Icon icon={wrench} className="w-6 h-6 text-gray-500" size={18}/>
            <div className={styles.pages8}>Services</div>
          </div>
          <div className={styles.icon3}>
            <img
              className={styles.chevronDownIcon6}
              alt=""
              src="/chevrondown.svg"
            />
          </div>
        </div>
      </div>
      <div className={styles.sidebarBottomIcons}>
        <div className={styles.icons}>
          <img
            className={styles.adjustmentsVerticalIcon}
            alt=""
            src="/adjustmentsvertical.svg"
          />
          <img className={styles.cogIcon} alt="" src="/cog.svg" />
          <img className={styles.globeIcon} alt="" src="/globe.svg" />
        </div>
      </div>
    </div>
  );
};

export default DashBoardSidebar;
